import { Box, styled } from '@mui/material';
import PhoneInput from 'react-phone-number-input';
import { RobotoFont } from '../../../styles/fonts';

export const MainWrapper = styled(Box)({
  backgroundColor: 'white',
  margin: '80px auto 70px',

  '& .container': {
    width: '607px',
    display: 'flex',
    flexDirection: 'column',
    gap: '17px',
    '@media only screen and (max-width: 1040px)': {
      minWidth: '299px',
      width: '100%',
      gap: '24px',
    },
    '@media only screen and (max-width: 281x)': {
      minWidth: '0px',
    },
  },
  '& .nameContainer': {
    display: 'flex',
    gap: '10px',
    '@media only screen and (max-width: 1040px)': {
      flexDirection: 'column',
      gap: '24px',
    },
  },
  '& .contactContainer': {
    display: 'flex',
    gap: '10px',
    '@media only screen and (max-width: 1040px)': {
      flexDirection: 'column',
      gap: '24px',
    },
  },
  '& .uploadFiles': {
    '@media only screen and (max-width: 1040px)': {
      marginBottom: '0px',
    },
  },
});

export const Input = styled('input')({
  width: '100%',
  padding: '10px 20px',
  border: '1px solid #D7D7D7',
  borderRadius: '2px',
  outline: 'none',
  fontFamily: RobotoFont.style.fontFamily,
  fontSize: '1rem',

  '::-webkit-input-placeholder': {
    color: '#C8C8C8',
  },

  '::-moz-placeholder': {
    color: '#C8C8C8',
  },
});

export const PhoneField = styled(PhoneInput)({
  width: '100%',
  border: '1px solid #D7D7D7',
  borderRadius: '2px',
  outline: 'none',
  fontFamily: RobotoFont.style.fontFamily,
  padding: '12px 40px!important',
  color: 'black!important',

  '& .PhoneInputInput': {
    border: 'none',
    outline: 'none',
    fontSize: '1rem',
    padding: 0,
  },

  '& .PhoneInputCountryIcon svg': {
    marginBottom: '4px',
  },
});

export const Textarea = styled('textarea')({
  width: '100%',
  padding: '10px 20px',
  border: '1px solid #D7D7D7',
  borderRadius: '2px',
  outline: 'none',
  fontFamily: RobotoFont.style.fontFamily,
  fontSize: '1rem',
  maxWidth: '607px',
  maxHeight: '200px',

  '::-webkit-input-placeholder': {
    color: '#C8C8C8',
  },

  '::-moz-placeholder': {
    color: '#C8C8C8',
  },
});

export const Files = styled(Box)({
  display: 'flex',
  gap: '20px',
});

export const FileWrapper = styled(Box)({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
});

export const baseStyle = {
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderColor: '#bdbdbd',
  borderStyle: 'dashed',
  backgroundColor: '#FFFF',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer',
  minHeight: '100px',
};

export const focusedStyle = {
  borderColor: '#2196f3',
};

export const acceptStyle = {
  borderColor: '#00e676',
};

export const rejectStyle = {
  borderColor: '#ff1744',
};
